let map;
let marker;
let circle70;
let circle150;
let geocoder;

function initMap() {
  map = new google.maps.Map(document.getElementById("map"), {
    center: { lat: 37.7749, lng: -122.4194 },
    zoom: 13,
    mapTypeId: google.maps.MapTypeId.SATELLITE,
    tilt: 0,
  });

  geocoder = new google.maps.Geocoder();
  const input = document.getElementById("address");
  const autocomplete = new google.maps.places.Autocomplete(input);
  autocomplete.bindTo("bounds", map);
  map.setMapTypeId(google.maps.MapTypeId["SATELLITE"]);
  map.addListener("click", (event) => {
    if (confirm("Are you sure you want to change the marker location?")) {
      placeMarkerAndCircles(event.latLng);
      getPlaceIdAndStoreData(event.latLng);
      smoothPanTo(event.latLng);
    }
  });
}

function placeMarkerAndCircles(location) {
  if (marker) marker.setMap(null);

  // Store the original location for cancellation
  const originalLocation = location;

  marker = new google.maps.Marker({
    position: location,
    map: map,
    draggable: true,
  });

  drawCircles(location);

  marker.addListener("dragend", () => {
    const newLocation = marker.getPosition(); // Get the new position
    if (confirm("Are you sure you want to change the marker location?")) {
      drawCircles(newLocation);
      getPlaceIdAndStoreData(newLocation);
      smoothPanTo(newLocation);
    } else {
      marker.setPosition(originalLocation); // Reset the marker to the original location
      smoothPanTo(originalLocation); // Smoothly pan the map to the new location
    }
  });

  marker.addListener("drag", () => {
    smoothPanTo(marker.getPosition());
  });
}

function drawCircles(location) {
  if (circle70) circle70.setMap(null);
  if (circle150) circle150.setMap(null);

  circle70 = new google.maps.Circle({
    strokeColor: "#FF0000",
    strokeOpacity: 0.15,
    strokeWeight: 2,
    fillColor: "#FF0000",
    fillOpacity: 0.15,
    map: map,
    center: location,
    //radius: 70 * 0.3048,
    //radius: 100 * 0.3048, // 100 feet in meters
    radius: 150 * 0.3048, // 150 feet in meters
  });
  // Add click listener for circle70
  google.maps.event.addListener(circle70, "click", (event) => {
    handleCircleClick(event.latLng);
  });

  circle150 = new google.maps.Circle({
    strokeColor: "#0000FF",
    strokeOpacity: 0.15,
    strokeWeight: 2,
    fillColor: "#0000FF",
    fillOpacity: 0.15,
    map: map,
    center: location,
    // radius: 150 * 0.3048,
    //radius: 300 * 0.3048, // 300 feet in meters (100 yards)
    radius: 1000 * 0.3048, // 1000 feet in meters
  });

  google.maps.event.addListener(circle150, "click", (event) => {
    handleCircleClick(event.latLng);
  });
}

function handleCircleClick(latLng) {
  const confirmChange = confirm(
    "Are you sure you want to change the marker location?"
  );
  if (confirmChange) {
    placeMarkerAndCircles(latLng);
    getPlaceIdAndStoreData(latLng);
    smoothPanTo(latLng);
  }
}

function ClickFunction() {
  const input = document.getElementById("address").value;
  if (input) {
    geocoder.geocode({ address: input }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK && results[0]) {
        const location = results[0].geometry.location;
        placeMarkerAndCircles(location);
        getPlaceIdAndStoreData(location);
        smoothPanTo(location);
        map.setZoom(21);
      } else {
        alert("Geocode was not successful for the following reason: " + status);
      }
    });
  } else {
    alert("Please enter an address.");
  }
}
async function StoreInDatabase(latitude, longitude, userAgent, placeId) {
  try {
    const response = await fetch(
      "https://sensor-demo.osxdemo.in/storeLocation.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ latitude, longitude, userAgent, placeId }),
      }
    );
    const result = await response.json();
    console.log("Server response:", result);
  } catch (error) {
    console.error("Error storing data:", error);
  }
}

function getPlaceIdAndStoreData(location) {
  geocoder.geocode({ location }, (results, status) => {
    if (status === google.maps.GeocoderStatus.OK && results[0]) {
      StoreInDatabase(
        location.lat(),
        location.lng(),
        navigator.userAgent,
        results[0].place_id
      );
    }
  });
}

function smoothPanTo(location) {
  map.panTo(location);
}
